import { Component, h, Prop, State, Watch } from "@stencil/core";
import { isBlank } from '../../utils';

@Component({
  tag: 'snap-avatar',
  styleUrl: 'snap-avatar.scss',
})
export class SnapAvatar {
  @Prop({ reflect: true, mutable: true }) imageSrc: string = ''

  @Prop({ reflect: true }) size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'profile' | 'profile-lg' = 'md'

  @Prop({ reflect: true }) imageAlt: string = 'avatar'

  @Prop({ reflect: true }) shape: 'circular' | 'rounded' | 'undefined' = 'circular'

  @Prop({ reflect: true }) notificationSide: 'top' | 'bottom' | 'undefined' | '' = ''

  @Prop({ reflect: true }) notificationColor: string = '#34D399'

  @Prop({ reflect: true }) profileName: string = ''

  @Prop({ reflect: true }) avatarTextTop: string = ''

  @Prop({ reflect: true }) avatarTextBottom: string = ''

  @Prop({ reflect: true }) avatarLink: string = ''

  @State() imageSrcLocal: string = ''

  @Watch('imageSrc')
  onImageUpdate() {
    this.imageSrcLocal = this.imageSrc
  }

  componentWillLoad() {
    this.onImageUpdate()
  }

  getClassesImg() {
    const classes = ['snap-avatar', `snap-avatar--${this.size}`]
    this.shape === 'circular' || this.shape === 'undefined' ? classes.push('img-rounded-full') : classes.push('img-rounded-md')
    return classes.join(' ').toString()
  }

  getClassesSpanNotification() {

    const classes = ['snap-avatar-notification']

    this.notificationSide === 'top' ? classes.push('notification-top') : classes.push('notification-bottom')

    if (this.notificationSide !== 'undefined' && this.notificationSide !== '') {
      if (this.shape === 'rounded') {
        this.notificationSide === 'top' ?
          classes.push('notification-top-transform') :
          classes.push('notification-bottom-transform')
      }
    }

    return classes.join(' ').toString()
  }

  getClassesSpanProfileName() {
    const classes = ['snap-avatar-initials', `snap-avatar-initials--${this.size}`]
    return classes.join(' ').toString()
  }

  getClassesSpanAvatarIconDefault() {
    const classes = ['snap-avatar-placeholder-icon', `snap-avatar-placeholder-icon--${this.size}`]
    return classes.join(' ').toString()
  }

  getProfileName() {
    if (this.profileName.trim() === '') {
      return
    }

    const buffer = this.profileName.trim().split(" ")
    let profileName = buffer[0][0]

    if (buffer.length > 1) {
      profileName += buffer[1][0]
    }

    return profileName
  }

  imgLoadError() {
    this.imageSrcLocal = ''
  }

  render() {
    // Avatar With Placeholder Initials
    if (!isBlank(this.profileName) && isBlank(this.imageSrcLocal)) {
      return (
        <span class={this.getClassesSpanProfileName()}>
          <span>{this.getProfileName()}</span>
        </span>
      )
    }
    // Avatar With Placeholder Icon
    else if (isBlank(this.profileName, this.imageSrcLocal, this.avatarTextTop)){
      return (
        <span class={this.getClassesSpanAvatarIconDefault()}>
          <svg fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
          </svg>
        </span>
      )
    }
    // Avatar With Text
    else if (!isBlank(this.avatarTextTop)) {
      return (
        <a href={this.avatarLink} class="snap-avatar-with-text">
          <div class="snap-avatar-with-text-wrapper">
            <div>
              {!isBlank(this.imageSrcLocal)
                ? <img class="snap-avatar-with-text-img" src={this.imageSrcLocal} alt={this.imageAlt} onError={() => this.imgLoadError()} />
                : <span class="snap-avatar-placeholder-icon snap-avatar-with-text-img">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </span>
              }
            </div>
            <div class="snap-avatar-with-text-right-wrapper">
              <slot />
              <p class="text-top">
                {this.avatarTextTop.trim()}
              </p>
              <p class="text-bottom">
                {this.avatarTextBottom.trim()}
              </p>
            </div>
          </div>
        </a>
      )
    }
    // Avatar Basic
    else if (isBlank(this.notificationSide)){
      return <img class={this.getClassesImg()} src={this.imageSrc} alt={this.imageAlt} onError={() => this.imgLoadError()} />
    }
    // Avatar with notification
    else {
      return (
        <span class="span-avatar-notification-wrapper">
          <img class={this.getClassesImg()} src={this.imageSrc} alt={this.imageAlt}/>
          <span class={this.getClassesSpanNotification()} style={{ backgroundColor: `${this.notificationColor}`}}></span>
        </span>
      )
    }
  }
}
